var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{staticClass:"text-center",attrs:{"dismissible":"","value":!!_vm.message,"type":_vm.type,"outlined":"","border":"left"},on:{"input":_vm.closeAlert}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }